import { TicketMemberField } from './TicketMemberField';
import { CustomField } from '../AllTypesExports';

export interface DtoTicketFieldItem {
    memberField: TicketMemberField;
    customField: CustomField | null;
    isRequired: boolean;
}

export function createDtoTicketFieldItem(dtoTicketFieldItem?: DtoTicketFieldItem | any) {
    let obj = <DtoTicketFieldItem>{
        memberField: TicketMemberField.Name,
        customField: null,
        isRequired: false
    };

    if (dtoTicketFieldItem) {
        Object.assign(obj, dtoTicketFieldItem);
    }

    return obj;
}